import { isObject } from "@/Utils/Objects";

import type { ApiError } from "../Models";

export const isApiError = (value: unknown): value is ApiError => {
  return isObject(value) && typeof value["error_code"] === "string" && typeof value["detail"] === "string";
};
